import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import cn from 'classnames';

import ReactPlayer from 'react-player';

export default class ReactPlayerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false
    };
    this.imageRef = React.createRef();
  }

  onPlayVideo = () => {
    this.setState({ playVideo: true, playing: true });
  };

  onEnd = () => {
    this.setState({ playing: false });
  };

  handleVisibilityChange = isVisible => {
    if (isVisible && this.props.canAutoplay) {
      this.onPlayVideo();
    }
  };

  render() {
    const { videoSrc, poster, alt, canAutoplay } = this.props;
    return (
      <div className="wrapper" onClick={this.onPlayVideo}>
        <VisibilitySensor
          onChange={this.handleVisibilityChange}
          scrollCheck
          partialVisibility={false}
        >
          <div className="video-wrapper">
            <iframe
              className="video-mobile"
              width="560"
              height="315"
              src={videoSrc}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <img src={poster} alt={alt} />
            <svg
              className={cn('play-button', { hide: this.state.playVideo })}
              width="120"
              height="120"
              viewBox="0 0 120 120"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M97.575 52.2585L31.575 13.2398C26.2125 10.071 18 13.146 18 20.9835V99.0023C18 106.034 25.6313 110.271 31.575 106.746L97.575 67.746C103.462 64.2773 103.481 55.7273 97.575 52.2585V52.2585Z"
                fill="#ffffff"
              />
            </svg>
            <div className="video-desktop">
              <ReactPlayer
                url={videoSrc}
                height="100%"
                width="100%"
                playing={this.state.playing}
                autoPlay={canAutoplay}
                allowFullScreen
                controls
                playsinline
                onEnded={this.onEnd}
              />
            </div>
          </div>
        </VisibilitySensor>
        <style jsx>{`
          .wrapper {
            position: relative;
          }
          .wrapper .svg-wrapper {
            padding: 50px 0;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
          .wrapper .svg-wrapper svg {
            width: 100%;
            height: 100%;
          }

          .video-wrapper {
            background: #000000;
            padding-bottom: 56.25%;
            border-radius: var(--border-radius);
            box-shadow: var(--box-shadow);
            overflow: hidden;
            position: relative;
          }
          .video-wrapper .video-desktop,
          .video-wrapper .video-mobile,
          .video-wrapper img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            object-fit: cover;
          }
          .video-wrapper img {
            z-index: 2;
            transition: opacity 1s ease-out;
            cursor: pointer;
          }
          .video-wrapper img.hide {
            opacity: 0;
            pointer-events: none;
          }
          .video-wrapper .video-desktop,
          .video-wrapper img,
          .video-wrapper .play-button {
            display: none;
          }
          @media (min-width: 992px) {
            .video-wrapper .video-desktop,
            .video-wrapper img,
            .video-wrapper .play-button {
              display: block;
            }
          }
          .video-wrapper .video-mobile {
            display: block;
          }
          @media (min-width: 992px) {
            .video-wrapper .video-mobile {
              display: none;
            }
          }
          .video-wrapper .play-button {
            position: absolute;
            top: calc(50% - 120px / 2);
            left: calc(50% - 120px / 2);
            z-index: 3;
            transition: opacity 500ms ease-out;
            pointer-events: none;
          }
          .video-wrapper .play-button.hide {
            opacity: 0;
            pointer-events: none;
          }
        `}</style>
      </div>
    );
  }
}
